const knowledge = {
  title: "Base de Conhecimento",
  description: "Gerencie a base de conhecimento do seu workspace",
  v2: {
    overview: "Visão geral",
    overviewComingSoon: "O painel de visão geral chega na próxima etapa do redesign.",
    groups: {
      base: "Base",
      infrastructure: "Infraestrutura",
    },
    documents: {
      count: "{{count}} itens",
      generatingEmbeddings: "gerando embeddings…",
    },
    embeddings: {
      count: "{{count}} vetores",
      searchBy: "Buscar por",
      metadataCount: "{{count}} metadados",
      noMetadata: "sem metadados",
    },
    contexts: {
      draft: "Rascunho",
      selectToEdit: "Selecione um contexto para editar",
    },
    overviewStats: {
      avgQuality: "Qualidade média",
      healthy: "Base saudável",
      synced: "Tudo sincronizado",
      assimilation: "Assimilação",
      lastUpdate: "Última atualização",
      publishedContexts: "Contextos publicados",
      recentDocuments: "Documentos recentes",
      seeAll: "Ver todos",
      relativeNow: "agora",
      relativeMin: "há {{count}} min",
      relativeHours: "há {{count}} h",
    },
  },
  tabs: {
    imports: "Importações",
    transformation: "Transformação",
    storage: "Armazenamento",
    pipelines: "Pipelines",
    database: "Banco de Dados",
    documents: "Documentos",
    embeddings: "Embeddings",
    settings: "Configurações"
  },
  fields: {
    type: "Tipo",
    name: "Nome",
    description: "Descrição",
    status: "Status",
    created_at: "Criado em",
    actions: "Ações"
  },
  actions: {
    import: "Importar",
    upload: "Upload",
    create: "Criar",
    edit: "Editar",
    delete: "Excluir",
    search: "Buscar",
    openMenu: "Abrir menu",
    view: "Ver Detalhes",
    actions: "Ações",
    filter: "Filtrar",
    next: "Próximo",
    previous: "Anterior",
    clear: "Limpar",
    cancel: "Cancelar",
    save: "Salvar",
  },
  common: {
    search: "Buscar",
    searchPlaceholder: "Buscar na base de conhecimento...",
    error: "Erro",
    success: "Sucesso",
    actions: "Ações",
    delete: "Excluir",
    cancel: "Cancelar",
    view: "Visualizar",
    openMenu: "Abrir menu",
    deleteSuccess: "Item excluído com sucesso",
    deleteError: "Erro ao excluir item",
    none: "Nenhum",
    actionOptions: {
      delete: "Excluir"
    }
  },
  imports: {
    title: "Armazenamento",
    description: "Armazene e gerencie seus dados de diferentes fontes",
    add: "Adicionar",
    search: "Buscar documentos...",
    error_loading: "Erro ao carregar dados do armazenamento",
    no_data: "Nenhum dado de armazenamento encontrado",
    no_workspace: 'Nenhum workspace selecionado',
    no_knowledge: 'Nenhuma base de conhecimento ativa encontrada',
    details: {
      description: "Ver detalhes do item de armazenamento"
    },
    fields: {
      file: "Arquivo",
      name: "Nome",
      type: "Tipo",
      category: "Categoria",
      status: "Status",
      size: "Tamanho",
      namePlaceholder: "Nome da importação",
      descriptionPlaceholder: "Descrição da importação",
      description: "Descrição",
      created_at: "Criado em",
      updated_at: "Atualizado em",
      file_size: "Tamanho",
      actions: "Ações",
      metadata: 'Metadados',
      quality: 'Qualidade',
      source: 'Origem'
    },
    metadata: {
      title: 'Metadados do documento',
      source: 'Origem',
      sourcePlaceholder: 'ex.: manual, meeting_scriber, api',
      subject: 'Assunto',
      subjectPlaceholder: 'Sobre o que é este documento?',
      language: 'Idioma',
      languagePlaceholder: 'ex.: pt-BR, en-US',
      tags: 'Tags',
      tagsPlaceholder: 'Tags separadas por vírgula'
    },
    empty: {
      title: "Nenhum item de armazenamento encontrado",
      description: "Adicione um novo item de armazenamento para começar"
    },
    messages: {
      success: "Dados armazenados com sucesso",
      error: "Erro ao armazenar dados",
      deleted: "Item de armazenamento excluído com sucesso",
      fetchError: "Erro ao carregar itens de armazenamento",
      createSuccess: "Item de armazenamento criado com sucesso",
      createError: "Erro ao criar item de armazenamento",
      successFileUpload: "Arquivo enviado com sucesso",
      successFileUploadDescription: "O arquivo {{file}} foi enviado com sucesso."

    },
    loadingDetails: "Carregando detalhes da ferramenta...",
    toolLoadError: "Não foi possível carregar os detalhes da ferramenta",
    validation: {
      requiredField: "Campo obrigatório",
      requiredFieldDescription: "O nome da importação é obrigatório.",
      requiredFields: "Campos obrigatórios",
      requiredFieldsDescription: "Os seguintes campos são obrigatórios: {{fields}}"
    },
    upload: {
      dragText: "Arraste e solte um arquivo aqui",
      anyFile: "Qualquer tipo de arquivo",
      acceptedType: "Tipo aceito: {{type}}",
      orText: "ou",
      selectButton: "Selecione um arquivo",
      maxSizeText: "Tamanho máximo: {{size}}",
      error: "Erro no upload",
      fileTooLarge: "Arquivo muito grande. Tamanho máximo: {{size}}",
      unsupportedType: "Tipo de arquivo não suportado. Aceito: {{type}}",
      removeFile: "Remover arquivo",
      sending: "Enviando arquivo",
      completed: "Upload concluído"
    },
    schedule: {
      enabled: "Agendamento ativado",
      frequency: "Frequência",
      frequencies: {
        hourly: "Por hora",
        daily: "Diário",
        weekly: "Semanal",
        monthly: "Mensal"
      },
      interval: "Intervalo",
      intervalPlaceholder: "Digite o intervalo",
      startTime: "Hora de início",
      daysOfWeek: "Dias da semana",
      dayOfMonth: "Dia do mês",
      dayOfMonthPlaceholder: "Digite o dia do mês",
      days: {
        0: "Dom",
        1: "Seg",
        2: "Ter",
        3: "Qua",
        4: "Qui",
        5: "Sex",
        6: "Sáb"
      }
    }
  },
  pipelines: {
    title: 'Pipelines',
    description: 'Gerencie seus pipelines de conhecimento',
    showing: 'Mostrando {{start}} até {{end}} de {{total}} pipelines',
    showing_pipelines: 'Mostrando {{start}} até {{end}} de {{total}} pipelines',
    itemsPerPage: 'Itens por página',
    noResults: 'Nenhum pipeline encontrado',
    no_data: 'Nenhum pipeline encontrado',
    addPipelineTitle: 'Adicionar Pipeline',
    addPipelineDescription: 'Selecione um pipeline disponível para instalar na sua base de conhecimento',
    available_templates: '{{count}} templates de pipeline disponíveis',
    available_templates_hint: 'Explore pipelines curados e instale o que melhor se encaixa no seu cenário.',
    no_available_pipelines: 'Nenhum pipeline disponível para instalação',
    integrations: 'Integrações',
    no_results: 'Sem resultados',
    install_pipeline: 'Instalar Pipeline',
    no_description: 'Sem descrição',
    pipeline_label: 'Template de pipeline',
    steps_count: '{{count}} etapas de instalação',
    quick_install: 'Instalação rápida',
    search_placeholder: 'Busque por nome, descrição ou integração...',
    actions: {
      create: 'Pipeline',
      search: 'Buscar pipelines...',
      filter: 'Filtrar',
      clear: 'Limpar busca',
      edit: 'Editar',
      delete: 'Excluir'
    },
    status: {
      active: 'Ativo',
      inactive: 'Inativo',
      error: 'Erro'
    },
    fields: {
      name: 'Nome',
      description: 'Descrição',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
      status: 'Status',
      actions: 'Ações'
    },
    empty: {
      title: 'Nenhum pipeline encontrado',
      description: 'Comece criando seu primeiro pipeline.'
    },
    errors: {
      loading: 'Erro ao carregar pipelines',
      deleting: 'Erro ao excluir pipeline'
    },
    confirmDelete: {
      title: 'Excluir pipeline',
      description: 'Tem certeza que deseja excluir este pipeline? Esta ação não pode ser desfeita.'
    }
  },
  embeddings: {
    title: "Embeddings",
    description: "Gerencie os embeddings da base de conhecimento",
    noResults: "Nenhum embedding encontrado",
    noEmbeddings: "Nenhum embedding encontrado",
    showing: "Mostrando {{start}} a {{end}} de {{total}} embeddings",
    itemsPerPage: "Itens por página:",
    search: "Buscar embeddings...",
    details: "Detalhes do Embedding",
    basicInfo: "Informações Básicas",
    view_details: "Ver Detalhes",
    fetchError: "Erro ao carregar embeddings",
    fetchDetailError: "Erro ao carregar detalhes do embedding",
    deleteSuccess: "Embedding excluído com sucesso",
    deleteError: "Erro ao excluir embedding",
    deleteConfirmTitle: "Excluir Embedding",
    deleteConfirmDescription: "Tem certeza que deseja excluir este embedding? Esta ação não pode ser desfeita.",
    fields: {
      id: "ID",
      content: "Conteúdo",
      metadata: "Metadados",
      version: "Versão",
      insertedAt: "Inserido em",
      knowledgeId: "ID da Base de Conhecimento",
      actions: "Ações"
    }
  },
  storage: {
    title: "Armazenamento",
    description: "Gerencie os arquivos da sua base de conhecimento",
    showing: "Mostrando {{start}} até {{end}} de {{total}} itens",
    itemsPerPage: "Itens por página",
    noResults: "Nenhum item encontrado",
    actions: {
      import: "Importar",
      upload: "Upload",
      search: "Buscar documentos...",
      filter: "Filtrar",
      clear: "Limpar busca",
      download: "Baixar",
      delete: "Excluir",
      viewDetails: "Ver detalhes",
      info: "Info"
    },
    source: {
      manual: "Manual",
      automatic: "Automática",
      unknown: "—"
    },
    details: {
      title: "Detalhes do documento",
      tabs: {
        details: "Detalhes",
        metadata: "Metadados",
        quality: "Qualidade",
        chunks: "Chunks"
      },
      fields: {
        fileName: "Nome do arquivo",
        fileSize: "Tamanho",
        fileType: "Tipo do arquivo",
        metadata: "Metadados",
        facets: "Facetas"
      },
      noMetadata: "Sem metadados",
      quality: {
        empty: "Sem estimativas de qualidade para este documento",
        overall: "Qualidade geral",
        completeness: "Completude",
        relevance: "Relevância",
        notAvailable: "Indisponível",
        processing: "Processamento",
        totalChunks: "Total de chunks",
        processedChunks: "Chunks processados",
        chunkMethod: "Estratégia de chunking",
        documentType: "Tipo de documento",
        model: "Modelo",
        provider: "Provedor",
        processedAt: "Processado em"
      },
      chunks: {
        total: "{{count}} chunks",
        empty: "Nenhum chunk indexado para este documento"
      },
      tabular: {
        schema: "Esquema",
        sheets: "Abas/Planilhas",
        rowCount: "{{count}} linhas",
        columnCount: "{{count}} colunas",
        degraded: {
          title: "Aba(s) indexada(s) em modo descritivo",
          description: "Abas com formatação complexa não viraram tabela consultável: continuam pesquisáveis por significado, mas não respondem a consultas exatas/agregações (somas, totais, contagens, filtros).",
          ruleLabel: "Quando isso acontece?",
          rule: "Quando a aba tem muitas células mescladas, cabeçalho em vários níveis, colunas sem nome ou linhas irregulares. Para respostas exatas, use uma tabela retangular limpa (um cabeçalho, um valor por célula)."
        }
      }
    },
    status: {
      active: "Ativo",
      pending: "Pendente",
      completed: "Concluído",
      failed: "Falhou",
      embedded: "Assimilado",
      processing: "Processando",
      stored: "Armazenado",
      partial: "Parcial"
    },
    fields: {
      type: "Tipo",
      name: "Nome",
      description: "Descrição",
      created_at: "Criado em",
      updated_at: "Atualizado em",
      file_size: "Tamanho",
      actions: "Ações",
      status: "Status"
    },
    empty: {
      title: "Nenhum item encontrado",
      description: "Comece importando seu primeiro item."
    },
    errors: {
      loading: "Erro ao carregar dados do armazenamento",
      deleting: "Erro ao excluir arquivo",
      downloading: "Erro ao baixar arquivo",
      downloadFailed: "Falha no download. Tente novamente."
    },
    messages: {
      downloadSuccess: "Arquivo baixado com sucesso",
      downloading: "Baixando arquivo..."
    },
    confirmDelete: {
      title: "Excluir arquivo",
      description: "Tem certeza que deseja excluir este arquivo? Esta ação não pode ser desfeita."
    },
    quickFilters: {
      all: 'Todos',
      type: 'Tipo',
      facets: 'Facetas',
      clear: 'Limpar',
      emptyTypes: 'Sem tipos disponíveis',
      emptyFacets: 'Sem facetas disponíveis',
      noMatches: 'Nenhum documento corresponde aos filtros aplicados'
    }
  },
  security: {
    tabTitle: "Segurança",
    title: "Segurança",
    description: "Ações irreversíveis para a base de conhecimento.",
    cleanupTitle: "Limpar Base de Conhecimento",
    cleanupDescription: "Remove todos os embeddings, arquivos de armazenamento e dados associados à base de conhecimento. Esta ação é permanente e não pode ser desfeita.",
    cleanupButton: "Limpar Tudo",
    confirmTitle: "Confirmar limpeza da base de conhecimento",
    confirmDescription: "Esta ação é irreversível. Digite o nome do produto para confirmar.",
    confirmLabel: "Digite o nome do produto para confirmar:",
    confirmButton: "Confirmar e Limpar",
    cleanupSuccess: "Base de conhecimento limpa com sucesso",
    cleanupError: "Erro ao limpar base de conhecimento",
    cleanupErrorDescription: "Ocorreu um erro ao tentar limpar a base de conhecimento.",
    cleanupErrorInvalid: "Produto não encontrado",
    cleanupErrorNameMismatch: "O nome do produto não corresponde",
    deleting: "Limpando...",
    deletingTitle: "Limpando Base de Conhecimento",
    deletingDescription: "Removendo embeddings e dados de {{name}}...",
    deletingStep: "Removendo dados",
    deletingMessage: "Aguarde enquanto removemos todos os dados...",
    deletedMessage: "Limpeza concluída",
    noKnowledgeBase: "Nenhum produto selecionado"
  },
  transformation: {
    title: "Transformação",
    description: "Transforme e prepare seus dados",
    add: "Adicionar transformação",
    nodes: "Nós de Transformação",
    fields: {
      name: "Nome",
      type: "Tipo",
      status: "Status",
      createdAt: "Criado em",
      updatedAt: "Atualizado em",
      actions: "Ações"
    },
    empty: {
      title: "Nenhuma transformação encontrada",
      description: "Adicione uma nova transformação para começar"
    },
    messages: {
      success: "Transformação salva com sucesso",
      error: "Erro ao salvar transformação",
      deleted: "Transformação excluída com sucesso",
      fetchError: "Erro ao carregar transformações",
      createSuccess: "Transformação criada com sucesso",
      createError: "Erro ao criar transformação",
      deleteSuccess: "Transformação excluída com sucesso",
      deleteError: "Erro ao excluir transformação"
    }
  },
  database: {
    title: "Banco de Dados",
    description: "Gerencie sua base de conhecimento",
    add: "Adicionar banco de dados",
    fields: {
      name: "Nome",
      type: "Tipo",
      status: "Status",
      createdAt: "Criado em",
      updatedAt: "Atualizado em",
      actions: "Ações"
    },
    empty: {
      title: "Nenhum banco de dados encontrado",
      description: "Adicione um novo banco de dados para começar"
    },
    messages: {
      success: "Banco de dados salvo com sucesso",
      error: "Erro ao salvar banco de dados",
      deleted: "Banco de dados excluído com sucesso",
      fetchError: "Erro ao carregar bancos de dados",
      createSuccess: "Banco de dados criado com sucesso",
      createError: "Erro ao criar banco de dados",
      deleteSuccess: "Banco de dados excluído com sucesso",
      deleteError: "Erro ao excluir banco de dados"
    }
  },
  errors: {
    subscriptionRequired: "Assinatura Expirada/Esgotada",
    subscriptionRequiredDescription: "Adicione mais créditos ou contrate outro plano para continuar fazendo upload de arquivos.",
    uploadFailed: "Falha no upload",
    genericUploadError: "Ocorreu um erro ao fazer o upload do arquivo. Tente novamente."
  },
  overview: {
    title: "Contextos",
    description: "Documente detalhes importantes do workspace",
    search_placeholder: "Buscar contextos...",
    sections: "Seções",
    section_titles: {
      vision: "Visão do Produto",
      product_vision: "Visão do Produto",
      value_proposition: "Proposta de Valor",
      target_audience: "Público-Alvo",
      stakeholders: "Stakeholders",
      user_personas: "Personas de Usuário",
      key_features: "Funcionalidades Principais",
      non_functional_requirements: "Requisitos Não-Funcionais",
      technical_architecture: "Arquitetura Técnica",
      risks_dependencies: "Riscos e Dependências",
      success_metrics: "Métricas de Sucesso",
      milestones_deadlines: "Marcos e Prazos",
      resources: "Recursos",
      section_1: "Seção 1",
      section_2: "Seção 2",
      section_3: "Seção 3",
      section_4: "Seção 4",
      section_5: "Seção 5",
      section_6: "Seção 6",
      section_7: "Seção 7",
      section_8: "Seção 8",
      section_9: "Seção 9",
      section_10: "Seção 10",
    },
    ai_hint: "Você pode gerar ou revisar todos os Contextos com IA usando este botão.",
    editor_ai_hint: "Regere o conteúdo desta seção com IA.",
    add_block: "Adicionar Seção",
    add: "Adicionar",
    write: "Escrever",
    upload: "Importar",
    upload_description: "Importar de arquivos markdown",
    upload_success: "{{count}} seção(ões) importada(s) com sucesso",
    upload_error: "Falha ao importar arquivo",
    upload_empty: "Nenhum conteúdo encontrado no arquivo",
    upload_invalid_type: "Tipo de arquivo inválido — apenas .md ou .zip são aceitos",
    drop_to_import: "Solte para importar",
    no_search_results: "Nenhuma seção corresponde à sua busca.",
    add_description: "Escreva suas próprias definições",
    generate_description: "Deixe a IA criar para você",
    generate_single_description: "Edite o prompt abaixo para guiar a IA na geração desta seção.",
    publish: "Publicar",
    edit_block: "Editar Seção",
    generate_blocks: "Gerar com IA",
    generate_section_title: "Gerar Seção com IA",
    generate_content: "Gerar Conteúdo",
    no_workspace: "Selecione um workspace para visualizar a visão geral",
    no_blocks: "O contexto do workspace está vazio. Adicione definições manualmente ou deixe a IA gerá-las para você.",
    block_title: "Título da Seção",
    block_title_placeholder: "Título da Seção",
    new_section_title: "Nova Seção",
    new_section_description: "Descreva o conteúdo desta seção",
    field_name: "Nome Técnico",
    field_name_help: "Nome usado nos placeholders (ex: vision, target_audience). Será gerado automaticamente a partir do título.",
    block_description: "Descrição",
    description_placeholder: "Descrição opcional da seção",
    block_type: "Tipo da Seção",
    content: "Conteúdo",
    fill_required_fields: "Preencha todos os campos obrigatórios",
    block_activated: "Seção ativada com sucesso",
    block_deactivated: "Seção desativada com sucesso",
    error_toggling: "Erro ao alternar status da seção",
    title_exists: "Já existe uma seção com este título",
    sync_to_kb: "Sincronizar com KB",
    blocks_generated: "Seções geradas com sucesso",
    content_generated: "Conteúdo gerado com sucesso",
    error_loading: "Erro ao carregar seções",
    error_creating: "Erro ao criar seção",
    error_updating: "Erro ao atualizar seção",
    error_deleting: "Erro ao deletar seção",
    error_generating: "Erro ao gerar seções",
    error_generating_content: "Erro ao gerar conteúdo",
    error_reordering: "Erro ao reordenar seções",
    field_name_exists: "Já existe uma seção com este nome técnico para este workspace",
    field_name_placeholder: "vision, target_audience, pain_points",
    content_placeholder_text: "Digite o texto...",
    content_placeholder_textarea: "Digite o conteúdo...",
    content_placeholder_link: "https://exemplo.com",
    content_placeholder_link_label: "Nome do link",
    content_placeholder_link_url: "URL",
    content_placeholder_add_link: "Adicionar Link",
    content_placeholder_add_item: "Adicionar Item",
    content_placeholder_language: "Linguagem",
    block_types: {
      text: { label: "Texto Simples", description: "Uma linha de texto", short: "texto" },
      textarea: { label: "Área de Texto", description: "Múltiplas linhas de texto", short: "texto" },
      rich_text: { label: "Texto Formatado", description: "Texto com formatação Markdown", short: "texto" },
      link: { label: "Link", description: "Um único link", short: "link" },
      links: { label: "Lista de Links", description: "Múltiplos links", short: "links" },
      list: { label: "Lista", description: "Lista de itens", short: "lista" },
      checklist: { label: "Checklist", description: "Lista com checkboxes", short: "lista" },
      code: { label: "Código", description: "Bloco de código", short: "código" },
      quote: { label: "Citação", description: "Bloco de citação", short: "citação" },
      callout: { label: "Destaque", description: "Caixa de destaque colorida", short: "destaque" },
      user_personas: { label: "Personas de Usuário", description: "Personas principais com objetivos, dores e características", short: "grupo" },
      group: { label: "Grupo", description: "Grupo de itens com nome, descrição e características", short: "grupo" }
    },
    read_only: "somente leitura",
    group_items: "Itens",
    group_item: "Item",
    unsaved_changes_title: "Alterações não publicadas",
    unsaved_changes_description: "Você possui alterações que ainda não foram publicadas. Se sair agora, essas mudanças serão perdidas.",
    unsaved_changes_continue: "Continuar Editando",
    unsaved_changes_discard: "Descartar e Sair",
    pending_changes_banner: "Você possui alterações não publicadas. Clique em Publicar para salvar.",
    undo_changes: "Desfazer",
    pending_changes_short: "Alterações não publicadas",
    publish_success: "Suas seções foram salvas e publicadas na visão geral.",
    all_blocks_cleared: "Todas as seções e embeddings foram removidos com sucesso.",
    include_in_knowledge: "Incluir na Base de Conhecimento",
    include_in_knowledge_help: "Quando ativado, esta seção estará disponível como placeholder no Assistente RAG",
    syncing_description: "Gerando seções da visão geral...",
    generating: "Gerando seções...",
    blocks_synced_to_kb: "seções sincronizadas com a Base de Conhecimento",
    sync_block_to_kb: "Sincronizar esta seção com a Base de Conhecimento",
    block_synced_to_kb: "Seção sincronizada com a Base de Conhecimento",
    error_syncing_block: "Erro ao sincronizar seção",
    persona: "Persona",
    personas: "Personas",
    persona_goals: "Objetivos:",
    persona_pain_points: "Dores:",
    persona_characteristics: "Características:",
    block_created: "Seção criada com sucesso",
    block_updated: "Seção atualizada com sucesso",
    block_deleted: "Seção excluída com sucesso",
    sync_started: "Sincronização iniciada - seções sendo sincronizadas com a Base de Conhecimento em segundo plano",
    recreating: "Recriando conteúdo...",
    editing: "Editando",
    view_mode: "Visualizar",
    edit_mode: "Editar",
    content_recreated: "Conteúdo recriado com sucesso",
    error_recreating: "Erro ao recriar conteúdo",
    view_markdown: "Ver como Markdown",
    view_normal: "Ver normal",
    view_full_content: "Ver conteúdo completo",
    view_more: "Ver mais",
    recreate_confirm_title: "Recriar conteúdo?",
    recreate_confirm_description: "Isso substituirá todo o conteúdo atual por um novo conteúdo gerado por IA. Essa ação não pode ser desfeita.",
    recreate_confirm_action: "Recriar",
    delete_confirm_title: "Excluir seção?",
    delete_confirm_description: "Essa ação não pode ser desfeita. A seção e seu conteúdo serão removidos permanentemente.",
    delete_confirm_action: "Excluir",
    recreate_all_blocks: "Recriar",
    recreate_all_confirm_title: "Recriar Todas as Seções?",
    recreate_all_confirm_description: "Isso deletará todas as seções atuais e gerará 10 seções padrão de visão geral usando IA. Todo o conteúdo atual será perdido. Esta ação não pode ser desfeita.",
    recreate_all_confirm_action: "Recriar Todas",
    blocks_recreated: "seções recriadas com sucesso",
    blocks_failed_recreate: "seções falharam ao recriar",
    error_recreating_all: "Erro ao recriar seções",
    generate_confirm_title: "Gerar Seções?",
    generate_confirm_description: "Isso gerará automaticamente seções de visão geral usando IA.",
    generate_confirm_action: "Gerar",
    settings: "Configurações",
    settings_title: "Configurações da Visão Geral",
    settings_tab_ai: "IA",
    settings_tab_security: "Segurança",
    settings_ai_title: "Geração com IA",
    settings_prompt_description: "Selecione um template abaixo ou escreva seu próprio prompt personalizado para gerar as seções.",
    settings_prompt_placeholder: "Selecione um template acima ou escreva um prompt personalizado aqui...",
    settings_templates_title: "Templates",
    settings_templates_loading: "Carregando templates...",
    settings_templates_error: "Não foi possível carregar os templates. Você ainda pode escrever um prompt personalizado.",
    settings_clear_prompt: "Limpar",
    settings_default_prompt: `Crie blocos de visão geral cobrindo os seguintes aspectos:

1. Visão da Solução - Do que se trata este projeto, seus objetivos, contexto estratégico e visão de longo prazo
2. Proposta de Valor - O que torna esta solução única e seus diferenciais
3. Stakeholders - Principais pessoas, equipes e papéis envolvidos no projeto
4. Público-Alvo - Usuários primários, segmentos de clientes e quem se beneficia
5. Personas de Usuário - Perfis principais de usuários (3-5) com objetivos, dores e comportamentos
6. Funcionalidades Principais - Recursos principais, capacidades e comportamentos esperados
7. Requisitos Não-Funcionais - Expectativas de desempenho, segurança, escalabilidade e disponibilidade
8. Arquitetura Técnica - Stack, integrações, infraestrutura e decisões técnicas principais
9. Riscos e Dependências - Riscos conhecidos, premissas, bloqueadores e dependências externas
10. Métricas de Sucesso - KPIs, critérios de aceitação e como o sucesso é medido
11. Marcos e Roadmap - Principais entregas, fases, prazos e iterações planejadas
12. Recursos - Links, repositórios, ambientes, documentação e referências

Gere conteúdo detalhado e específico baseado no contexto do projeto. Evite texto genérico.`,
    settings_security_title: "Zona de Perigo",
    settings_security_description: "Ações destrutivas que não podem ser desfeitas.",
    settings_clear_title: "Limpar Visão Geral",
    settings_clear_description: "Remove todas as seções permanentemente. Esta ação não pode ser desfeita.",
    settings_clear_action: "Limpar Tudo",
    settings_clear_confirm: "Tem certeza? Todas as seções serão excluídas permanentemente.",
    settings_regenerate_title: "Recriar com IA",
    settings_regenerate_description: "Exclui todas as seções e gera novas usando IA com base no prompt configurado.",
    settings_regenerate_action: "Recriar Tudo",
    settings_regenerate_hint: "O prompt acima será utilizado para recriar todas as seções da visão geral.",
    settings_max_tokens: "Max Tokens",
    settings_temperature: "Temperatura",
    settings_generate_title: "Gerar Visão Geral",
    settings_generate_action: "Gerar"
  }
} as const;

export default knowledge;
